import React , {useState, useEffect} from 'react';
import "../../styles/Acceuil.css";
import ltickets from '../../assets/ticket.jpg';
import prod from '../../assets/rouge.webp';
import xo from '../../assets/tente.webp';
import vdu from '../../assets/accueil.jpg';
import { useTranslation } from 'react-i18next';
import '../../../i18n'; 
import { useNavigate } from "react-router-dom";

import { Link } from 'react-router-dom';
import ServiceSection from "./ServiceSection";
import { useCart } from "../CartContext";

const Accueil = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(); 
  const { cart, setCart, cartCount, setCartCount } = useCart();
  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language); // Changer la langue
  };

  const lang = localStorage.getItem('language') || "FRA";
  let newlang = ""; // Utilisez let au lieu de const

  if (lang === "FRA" || lang === "FR" || lang === "") {
    newlang = 'FR';
  } else if (lang === "ENG") {
    newlang = 'EN';
  } else if (lang === "ESP") {
    newlang = 'ES';
  } else if (lang === "POT") {
    newlang = 'PT';
  }

  const translateText = async (text, targetLanguage) => {
    if (targetLanguage === 'FR') {
      return text; // Si la langue cible est déjà le français, ne traduisez pas.
    }
    const apiKey = process.env.REACT_APP_DEEPL_API_KEY;
    const url = process.env.REACT_APP_DEEPL_URL;

    const params = new URLSearchParams();
    params.append("auth_key", apiKey);
    params.append("text", text);
    params.append("target_lang", targetLanguage);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });

      const data = await response.json();

      if (data.translations && data.translations[0] && data.translations[0].text) {
        return data.translations[0].text;
      } else {
        return text; // Retournez le texte original si la traduction échoue
      }
    } catch (error) {
      return text; // Retournez le texte original en cas d'erreur
    }
  };

  const [pickupPoint, setPickupPoint] = useState({ sale_points: [] });
  const [loading, setLoading] = useState(true); // État pour gérer le chargement
  const [translatedPickupPoints, setTranslatedPickupPoints] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/shop/sale-points`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_API_KEY,
          },
        });

        if (!response.ok) {
          if (response.status === 500) {
            // Redirection vers la page 500
            navigate("/500");
          }
          throw new Error(`Erreur HTTP : ${response.status}`);
        }

        const data = await response.json();
        setPickupPoint(data);
        const translatedPoints = await Promise.all(
          data.sale_points.map(async (point) => {
            const translatedName = await translateText(point.name, newlang);
            const translatedAddress = await translateText(point.address, newlang);
            return { ...point, name: translatedName, address: translatedAddress };
          })
        );
        setTranslatedPickupPoints(translatedPoints);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [newlang, navigate]);



  return (
    <div className="homepage">
  
    {/* HERO SECTION */}
    <section id="hero" className="hero">
      <div className="hero-text">
        <h2>{t("hero_title")}</h2>
        <p>{t("hero_description")}</p>
        <div className="pickup-points">
        <ul>
          {translatedPickupPoints.map((point, index) => (
            <li key={index}>
              <strong>{point.name}</strong> - {point.address}
            </li>
          ))}
        </ul>
      </div>
      <a href="#products" className="btn-primary">
          {t("see_products")}
        </a>
      </div>

      <div className="hero-image">
        <img src={vdu} alt="Hero" />
      </div>
    </section>

    {/* PRODUCTS SECTION */}
    <section id="products" className="ecommerce-products-section">
      <h2 className="ecommerce-section-title">{t("categories_title")}</h2>
      <div className="ecommerce-product-cards">
        <div className="ecommerce-product-card">
          <div className="ecommerce-product-image">
            <img src={ltickets} alt="Tickets" />
          </div>
          <div className="ecommerce-product-info">
            <h3>{t("tickets_title")}</h3>
            <p>{t("tickets_description")}</p>
            <Link to="/tickets" className="ecommerce-btn-primary">{t("achat")}</Link>
          </div>
        </div>
        <div className="ecommerce-product-card">
          <div className="ecommerce-producte-image">
            <img src={prod} alt="Produits" />
          </div>
          <div className="ecommerce-product-info">
            <h3>{t("products_title")}</h3>
            <p>{t("products_description")}</p>
            <Link to="/produits" className="ecommerce-btn-primary">{t("achat")}</Link>
          </div>
        </div>
        <div className="ecommerce-product-card">
          <div className="ecommerce-productei-image">
            <img src={xo} alt="Tentes" />
          </div>
          <div className="ecommerce-product-info">
            <h3>{t("tents_title")}</h3>
            <p>{t("tents_description")}</p>
            <Link to="/tentes" className="ecommerce-btn-primary">{t("discover")}</Link>
          </div>
        </div>
      </div>
    </section>
    <div>
      <ServiceSection />
      </div>
  </div>
  
  );
};

export default Accueil;
